<script setup lang="ts">
import { computed } from 'vue'
import { VIcon } from '@/modules/shared/components'

interface PaymentStyle {
  label: string
  text: string
  dot: string
  check: boolean
}

const props = defineProps<{
  status: string | null | undefined
}>()

const STYLES: Record<string, PaymentStyle> = {
  paid: { label: 'Paid', text: 'text-green-600', dot: '', check: true },
  unpaid: { label: 'Unpaid', text: 'text-red-600', dot: 'bg-red-500', check: false },
  reconciled: { label: 'Reconciled', text: 'text-sky-600', dot: 'bg-sky-500', check: false },
  uncollectible: { label: 'Uncollectible', text: 'text-gray-600', dot: 'bg-gray-400', check: false },
  unknown: { label: 'Unknown', text: 'text-amber-600', dot: 'bg-amber-500', check: false },
  'no services': { label: 'No services', text: 'text-gray-500', dot: 'bg-gray-400', check: false },
}

const style = computed<PaymentStyle | null>(() => (props.status ? (STYLES[props.status] ?? null) : null))
</script>

<template>
  <template v-if="style">
    <span class="inline-flex items-center gap-1.5 text-sm font-medium" :class="style.text">
      <VIcon v-if="style.check" name="Check" class="h-4 w-4" />
      <span v-else class="h-2 w-2 rounded-full" :class="style.dot"></span>
      <span>{{ style.label }}</span>
    </span>
  </template>
  <span v-else class="text-sm text-gray-400">—</span>
</template>
